import { TagList } from '../tag-list';

type Props = {
  characteristics: {
    __typename?: 'JobDescriptionsCharacteristic' | undefined;
    id: number;
    name: string;
    isMatched?: boolean;
  }[];
  maxCount?: number;
};

export const CharacteristicTagList = ({ characteristics, maxCount }: Props) => {
  const rawTags = maxCount
    ? characteristics.slice(0, maxCount)
    : characteristics;
  const tags = rawTags.map((tag) => ({
    key: tag.id,
    name: tag.name,
    isMatched: tag.isMatched,
  }));

  return <TagList tags={tags} />;
};
